// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__11onQ","ranges":"BmiRanges_ranges__1TQnH"};